import { render } from "./ButtonSelector.vue?vue&type=template&id=eb4cdd00&scoped=true"
import script from "./ButtonSelector.vue?vue&type=script&lang=js"
export * from "./ButtonSelector.vue?vue&type=script&lang=js"

import "./ButtonSelector.vue?vue&type=style&index=0&id=eb4cdd00&scoped=true&lang=css"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4cdd00"]])

export default __exports__